import * as types from '../mutations'

const services = {
  tax: window.abp.services.app.tax
}

// initial state
const state = {
  all: [],
  pagination: {},
  activeTax: {}
}

// getters
const getters = {
  allTaxes: state => state.all,
  allTaxesPagination: state => state.pagination,
  activeTax: state => state.activeTax
}

// actions
const actions = {
  getTaxes({ commit }, request) {
    if (!request) {
      request = {}
    }
    return new Promise((resolve, reject) => {
      services.tax.getList(request).done(function (response) {
        let taxes = response.items
        let pagination = {
          currentPage: response.currentPage,
          totalCount: response.totalCount,
          totalPage: response.totalPage
        }
        commit(types.DATA.RECEIVE_TAXES, { taxes, pagination })
        resolve()
      })
    })
  },
  getTax({ commit }, id) {
    let request = { id: id }
    return new Promise((resolve, reject) => {
      if (!request.id) {
        commit(types.DATA.UPDATE_ACTIVE_TAX, {})
        resolve()
      } else {
        services.tax.get(request).done(function (response) {
          commit(types.DATA.UPDATE_ACTIVE_TAX, response)
          resolve()
        })
      }
    })
  },
  createOrUpdateTax({ commit }, tax) {
    return new Promise((resolve, reject) => {
      let action = tax.id !== '' ? services.tax.update(tax) : services.tax.create(tax)
      action
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_TAX, response)
          resolve()
        })
        .fail(function (response) {
          commit(types.DATA.SET_VALIDATION_ERRORS, response)
          reject()
        })
    })
  },
  deleteTax({ commit }, id) {
    return new Promise((resolve, reject) => {
      services.tax.delete({ id: id })
        .done(function (response) {
          commit(types.DATA.REMOVE_VALIDATION_ERRORS)
          commit(types.DATA.UPDATE_ACTIVE_TAX, {})
          resolve()
        })
    })
  }
}

// mutations
const mutations = {
  [types.DATA.RECEIVE_TAXES](state, { taxes, pagination }) {
    state.all = taxes
    state.pagination = pagination
  },
  [types.DATA.UPDATE_ACTIVE_TAX](state, tax) {
    state.activeTax = tax
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./scripts/store/modules/taxes.js